var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76615 13.6843C6.70102 13.5789 6.66656 13.4574 6.66661 13.3335V9.33346C6.66646 9.00304 6.54363 8.68445 6.32191 8.43945L1.50478 3.11335C1.41839 3.01764 1.36161 2.89893 1.34132 2.77161C1.32102 2.64428 1.33809 2.51381 1.39044 2.39598C1.4428 2.27816 1.5282 2.17804 1.6363 2.10776C1.7444 2.03748 1.87056 2.00005 1.9995 2H14.0007C14.1295 2.0003 14.2555 2.03792 14.3634 2.1083C14.4713 2.17868 14.5565 2.27882 14.6086 2.39659C14.6608 2.51436 14.6778 2.64473 14.6574 2.77194C14.6371 2.89914 14.5803 3.01772 14.494 3.11335L9.67824 8.43945C9.45652 8.68445 9.33369 9.00304 9.33354 9.33346V14.0002C9.33359 14.1139 9.30458 14.2256 9.24928 14.3249C9.19397 14.4242 9.11419 14.5077 9.01753 14.5675C8.92086 14.6273 8.81052 14.6614 8.69697 14.6665C8.58343 14.6717 8.47045 14.6477 8.36878 14.5969L7.03532 13.9302C6.92448 13.8748 6.83127 13.7897 6.76615 13.6843Z",
    stroke: "#005BF0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b458cbd3227fc98451c2e42d0ab91942.svg";
export { ForwardRef as ReactComponent };